export function scrollToSection (section) {
    const sectionElement = document.getElementById(section);
    window.scrollTo({
        top: sectionElement.offsetTop - 100,
        behavior: "smooth"
    });
    // const navbarMenu = document.getElementById('navbarBasic');
    // navbarMenu.classList.remove('display-block');
  }